import {
  type ValidatorFunction,
  type ValidatorResult,
} from 'ember-changeset-validations';
import { getIntl } from 'uplisting-frontend/validators/-internal';

interface CoordinateOptions {
  min: number;
  max: number;
}

export function validateCoordinate(
  validationMessageKey: string,
  options: CoordinateOptions,
): ValidatorFunction {
  return (_key: string, newValue: unknown): ValidatorResult => {
    if (newValue === null || newValue === undefined || newValue === '') {
      return true;
    }

    const num = Number(newValue);

    if (isNaN(num) || num === 0 || num < options.min || num > options.max) {
      return getIntl().t(`validation_messages.custom.${validationMessageKey}`);
    }

    return true;
  };
}
